import { useCallback, useEffect, useMemo } from 'react'

import { getUniqueId } from '@/utils'

import { IntercomSetup, isIntercomEnabled } from './constants'

export function useIntercom() {
  const isEnabled = useMemo(() => IntercomSetup.appId && isIntercomEnabled, [])

  const boot = useCallback((metadata: Record<string, unknown> = {}) => {
    if (!window || !window.Intercom || !IntercomSetup.appId) return

    window.Intercom('boot', { app_id: IntercomSetup.appId, ...metadata })
  }, [])

  const update = useCallback((metadata: Record<string, unknown> = {}) => {
    window &&
      window.Intercom &&
      window.Intercom('update', { app_id: IntercomSetup.appId!, ...metadata })
  }, [])

  const updateForRouteChange = useCallback(() => {
    update()
  }, [update])

  const identify = useCallback(
    (
      identifier: string,
      metadata: Record<string, unknown> & { email: string },
    ) => {
      update({ ...metadata, user_id: identifier })
    },
    [update],
  )

  const reset = useCallback(() => {
    identify(getUniqueId(), {
      email: 'UNKNOWN_USER',
    })
  }, [identify])

  useEffect(() => {
    if (!IntercomSetup.appId) {
      console.warn('Intercom appId is not set')
    }
  }, [])

  return isEnabled ? { boot, updateForRouteChange, identify, reset } : null
}
